angular.module('impactx.controlstructure').directive('appBudgetView', [function () {
    return {
        scope: {
            budget: '=',
            requiredMessage: '=',
            dialogData: '='
        },
        restrict: 'E',
        templateUrl: 'modules/control/templates/dialogs/budget.html',
        transclude: true
    };
}]);